<template>
  <v-system-bar
    v-if="!tableAllocationCTAVisible"
    style="max-height: 28px; min-height: 28px"
    height="28"
    color="warning"
  >
    <confirmation-dialog
      :message="$t('message.settings_change_not_allowed')"
      hide-cancel
      :confirm-title="$t('button.ok')"
      :visible="dialogVisible"
      :cancel-title="undefined"
      @close="dialogVisible = false"
    />
    <template v-if="$vuetify.breakpoint.smAndUp">
      <v-icon color="black">
        mdi-alert
      </v-icon>
      <span class="font-weight-medium black--text mr-1">{{ $t('label.tip') }}:</span>
    </template>
    <i18n
      path="label.cta_table_allocation"
      tag="span"
      class="black--text ellipsize"
    >
      <router-link
        v-if="userSettingsAllowed"
        to="/settings/advanced"
        class="blue--text"
      >
        {{ $t('label.cta_table_allocation_turn_on') }}
      </router-link>
      <a
        v-else
        class="blue--text"
        href="#"
        @click="dialogVisible=true"
      >{{ $t('label.cta_table_allocation_turn_on') }}</a>
    </i18n>
  </v-system-bar>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog.vue';
import User from '@/model/User';

export default Vue.extend({
  name: 'TableAllocationCTA',
  components: { ConfirmationDialog },
  props: { },
  data() {
    return { dialogVisible: false };
  },
  computed: {
    tableAllocationCTAVisible(): boolean {
      const { tableAllocation } = this.$tstore.state.settings.accountSettings;
      return tableAllocation === true || tableAllocation === undefined;
    },
    userSettingsAllowed(): boolean {
      const activeUser = this.$tstore.getters.activeUser as User | undefined;
      return activeUser?.allowSettings || false;
    },
  },
  methods: { },
});
</script>
